export const AMEX_SDK_NAME = 'AmexProxySdk.js';
export const MA_SDK_NAME = 'mastercard.js';
export const VISA_SDK_NAME = 'visaSdk.js';
export const VISA_SDK_URI = '/checkout-widget/resources/js/src-i-adapter/visaSdk.js';
